import { Flame as Flame_kojaro } from './Flame.kojaro';
import { Flame as Flame_phosphor } from './Flame.phosphor';
import { Flame as Flame_zoomg } from './Flame.zoomg';
import { Flame as Flame_zoomit } from './Flame.zoomit';

const IconRenderer = () => {
  switch (process.env.NEXT_PUBLIC_ICON_SYSTEM) {
    case 'kojaro':
      return Flame_kojaro;

    case 'zoomg':
      return Flame_zoomg;

    case 'phosphor':
      return Flame_phosphor;

    default:
      return Flame_zoomit;
  }
};

export const Flame = IconRenderer();
